module.exports = __webpack_public_path__ + "static/media/spritual3.09f6e6a1.webp";